import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { PageFrame } from './components/PageFrame'

const HomePage = lazy(() => import('./pages/HomePage'))
const DuoPage = lazy(() => import('./pages/DuoPage'))
const DuoArticlePage = lazy(() => import('./pages/DuoArticlePage'))
const WorkPage = lazy(() => import('./pages/WorkPage'))
const WorkDetailPage = lazy(() => import('./pages/WorkDetailPage'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))

export function App() {
  return (
    <PageFrame>
      <Suspense fallback={<div className="route-loading" role="status">Loading…</div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/iphone-duo" element={<DuoPage />} />
          <Route path="/iphone-duo/:slug" element={<DuoArticlePage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/work/:slug" element={<WorkDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </PageFrame>
  )
}
